<template>
    <div class="topdiv">
        <p class="main_title">我的发票</p>
        <Table class="mytableframe" :no-data-text="nodatatxt" :columns="columns" :data="data" width="100%" v-cloak height="740">
            <template slot-scope="{ row }" slot="action">
                <Button :disabled="!(row.invoicestatus===1 && row.paystatus===100 && row.actualamount>=1)" size="small" style="margin-right: 10px" type="primary" @click="showInvoice(row,1)">开具发票</Button>
                <Button :disabled="!(row.invoicestatus===901 || row.invoicestatus===940)" size="small" @click="lookRow(row)" style="margin-right: 10px" type="primary">查看发票</Button>
                <Button :disabled="!(row.invoicestatus===901)" size="small" @click="showSendModal(row)" style="margin-right: 10px" type="primary">发送邮箱</Button>
                <Button :disabled="!(row.allowinvoicereplace)" size="small" type="primary" @click="showInvoice(row,2)">申请换开</Button>
                <!-- <div v-if="row.invoicechangestatus>0" style="display: inline-block;width: 50px;color:#19be6b;">{{row.invoicechangestatusdesc}}</div>
                <div v-else style="display: inline-block;width: 100px;">
                    <Button :disabled="row.invoicestatus!==901" size="small" type="primary" @click="showInvoice(row)">申请换开</Button>
                </div> -->
            </template>
        </Table>
        <Member ref="mymember_agreement" />
        <VIP ref="myvip_agreement" />
        <Modal v-model="modal2" width="480" :mask-closable=false>
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <span>请输入收取电子发票的邮箱地址</span>
            </p>
            <div style="text-align:center;margin:20px;">
                <span>电子邮箱地址：</span>
                <Input v-model="value1" placeholder="请输入收取电子发票的邮箱地址" style="width: 300px" />
            </div>
            <div slot="footer">
                <Button type="primary" @click="cancelModal">取消</Button>
                <Button type="primary" @click="sendRow">发送</Button>
            </div>
        </Modal>
        <Modal v-model="modalInvoice" width="700" :mask-closable="false" :transfer="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <Icon type="ios-information-circle"></Icon>
                <span>发票信息</span>
            </p>
            <div>
<!--                 <Invoice ref='myInvoice' :isReissue="true" /> -->
               <!--  <img src="../../assets/images/nodata@2x.png" /> -->
                <Invoice ref='myInvoice'/>
            </div>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelInvoice">取消</Button>
                <Button type="primary" size="large" @click="getInvoiceInfo">开具发票</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import MemberAgreement from './product_agreement.vue'
import invoice from "./myinvoice.vue"
import VIPAgreement from './product_package_agreement.vue'
import ConstJson from '../../api/common/constjson'
import store from "../../store/"
let constJ = new ConstJson()
export default {
    data() {
        return {
            nodatatxt:"<img src='/resource/images/nodata.png' style='height:\'98px;\' width=\'66px;\'' />",
            takeInvoiceStatus:1,//1=开具发票,2=换开发票
            sonheadertype: 1,
            myInvoiceHeader: {
                bankaccount: "",
                bankname: "",
                headercode: "",
                headername: "个人",
                headertype: 1,
                invoiceTotal: 0,
                mobilenumber: "",
                officeaddress: "",
                postaddress: "",
                postemail: "",
                postmobile: "",
            },
            invoiceHeaderName: '个人',
            invoiceType: 1,
            modalInvoice: false,
            processrow: null,
            modal2: false,
            value1: '',
            data: [],
            columns: [{
                    title: '订单号',
                    key: 'orderid',
                    //minWidth: 250

                },
                {
                    title: '名称',
                    key: 'product_desc',
                    //minWidth: 255

                },
                {
                    title: '金额',
                    key: 'actualamount',
                    //minWidth: 250

                },
                {
                    title: '发票状态',
                    key: 'invoicestatusdesc',
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'left',
                    width: 380
                }
            ]
        }
    },
    created() {
        this.show()
    },
    components: {
        'Member': MemberAgreement,
        'VIP': VIPAgreement,
        'Invoice': invoice,
    },
    methods: {
        //获取合同信息
        getOrderContract(row) {
            let isShowSignDate = false
            //獲取合同信息
            console.log('查看合同orderid:' + row.orderid)
            constJ.reqGetOrderContract(row.orderid).then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    //this.showQRAndCheckPayStatus()
                    if (row.ordertype === 10) {
                        if (row.paystatus === 100) {
                            isShowSignDate = true
                        }
                        this.$refs.mymember_agreement.createdata(res.item, isShowSignDate)
                        this.$refs.mymember_agreement.show()
                    } else if (row.ordertype === 20) {
                        if (row.paystatus === 100) {
                            isShowSignDate = true
                        }
                        this.$refs.myvip_agreement.createdata(res.item, isShowSignDate)
                        this.$refs.myvip_agreement.show()
                    }

                }
            })
        },
        cancelInvoice() {
            this.modalInvoice = false
        },
        getInvoiceInfo() {
            console.log(this.$refs.myInvoice.formData.headertype)
            //console.log("this.productNewPrice:"+this.productNewPrice)
            this.$refs.myInvoice.$refs.formData.validate((valid) => {
                if (valid) {
                    if (this.$refs.myInvoice.formData.headertype == 1) {
                        this.$refs.myInvoice.formData.headercode = ''
                        this.$refs.myInvoice.formData.officeaddress = ''
                        this.$refs.myInvoice.formData.mobilenumber = ''
                        this.$refs.myInvoice.formData.bankname = ''
                        this.$refs.myInvoice.formData.bankaccount = ''
                        // this.$refs.myInvoice.formData.postaddress = ''
                        // this.$refs.myInvoice.formData.postemail = ''
                        // this.$refs.myInvoice.formData.postmobile = ''
                    }
                    this.sonheadertype = Number(this.$refs.myInvoice.formData.headertype)
                    console.log(this.sonheadertype);
                    this.$refs.myInvoice.remData = JSON.parse(JSON.stringify(this.$refs.myInvoice.formData))
                    this.$refs.myInvoice.remheadertype = this.$refs.myInvoice.formData.headertype
                    let _invoiceType = this.$refs.myInvoice.invoicetype
                    let invoiceHeader = { ...this.$refs.myInvoice.formData }
                    //this.invoiceHeaderName = this.$refs.myInvoice.formData.headername
                    this.invoiceHeaderName = this.$refs.myInvoice.formData.headertype == 1 ? '个人' : '单位'
                    this.invoiceType = Number(_invoiceType)
                    this.myInvoiceHeader = invoiceHeader
                    this.myInvoiceHeader.headertype = Number(invoiceHeader.headertype)

                    //发票信息
                    let _invoice = {
                        orderid: this.processrow.orderid,
                        invoicetype: this.invoiceType,
                        invoiceheader: this.myInvoiceHeader
                    }

                    console.log(_invoice, this.processrow)

                    // let invoice = {
                    //     orderid: this.processrow.orderid,
                    //     invoice: _invoice.invoicetype,
                    //     headertype: _invoice.invoiceheader.headertype,
                    //     headername: _invoice.invoiceheader.headername,
                    //     headercode: _invoice.invoiceheader.headercode,
                    //     officeaddress: _invoice.invoiceheader.officeaddress,
                    //     mobilenumber: _invoice.invoiceheader.mobilenumber,
                    //     bankname: _invoice.invoiceheader.bankname,
                    //     bankaccount: _invoice.invoiceheader.bankaccount,
                    //     postaddress: _invoice.invoiceheader.postaddress,
                    //     postemail: _invoice.invoiceheader.postemail,
                    //     postmobile: _invoice.invoiceheader.postmobile,
                    // }
                    this.modalInvoice1 = true
                    this.checkIsReInvoice(_invoice)

                } else {
                    this.$Message.error('请填写必填项！');
                    return
                }
            })



        },
        //重开发票二次确认
        checkIsReInvoice(po) {
            this.$Modal.confirm({
                title: '请核对您填写开票信息',
                content: this.takeInvoiceStatus===1?'<p>确认开具发票？</p>':'<p>确认换开发票？</p>',
                cancelText: "否",
                okText: '确认开票',
                onOk: () => {
                    if(this.takeInvoiceStatus===1){
                        //开具发票
                        this.reTakeaNewInvoice(po)
                    }else if(this.takeInvoiceStatus===2){
                        //换开
                        this.takeInvoiceAgain(po)
                    }
                    
                },
                onCancel: () => {
                    return
                }
            });
        },

        //开具发票
        reTakeaNewInvoice(parms) {
            constJ.reqTakeNewInvoice(parms).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.modalInvoice = false
                        this.$Message.success('开具发票成功！')
                        //刷新状态
                        this.show()

                    } else {
                        this.$Message.warning(res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning(res.rtndesc)
                    return
                }
            })
        },
        //换开发票
        takeInvoiceAgain(parms) {
            constJ.reqTakeInvoiceAgain(parms).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.modalInvoice = false
                        this.$Message.success('换开发票成功！')
                        //刷新状态
                        this.show()

                    } else {
                        this.$Message.warning(res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning(res.rtndesc)
                    return
                }
            })
        },

        //申请换开发票
        // reInvoice(parms) {
        //     constJ.reqReSendInvoice(parms).then(res => {
        //         console.log(res)
        //         if (res.rtncode === 1) {
        //             if (res.rltcode === 1) {
        //                 this.modal2 = false
        //                 this.$Message.success(res.rltdesc)
        //                 //刷新状态
        //                 this.show()

        //             } else {
        //                 this.$Message.warning(res.rltdesc)
        //                 return
        //             }
        //         } else {
        //             this.$Message.warning(res.rtndesc)
        //             return
        //         }
        //     })
        // },
        //type=1 开具发票  type=2 换开发票
        showInvoice(row,type) {
            this.takeInvoiceStatus=type
            this.processrow = row
            this.modalInvoice = true
            //读取发票信息
            this.$refs.myInvoice.getInvoice()
        },
        // 查看
        lookRow(row) {
            console.log(row);
            // row.invoicepdfurl = 'https://invtest.nntest.cn/fp/rhgeyLUa993WwXEfsBbwyeNSBxshSMvbrpLYTjOD3hLCPomcyuNFMTg6Ph9WTQksyn_BxZN9saoxwGHRGsWV8w.pdf'
            window.open(row.invoicepdfurl)
            //this.getOrderContract(row)
        },
        cancelModal() {
            this.modal2 = false
        },
        showSendModal(row) {
            this.modal2 = true
            this.value1 = ''
            this.processrow = row
            // this.$Modal.confirm({
            //     render: (h) => {
            //         return h('div', ['电子邮箱：', h('Input', {
            //             props: {
            //                 value: this.value1,
            //                 autofocus: true,
            //                 placeholder: '请输入收取电子发票的邮箱地址',
            //             },
            //             domProps: {
            //                 style: 'width:280px;',
            //             },
            //             on: {
            //                 input: (val) => {
            //                     this.value1 = val;
            //                     //console.log(val)
            //                 }
            //             }
            //         }), ''])
            //     },
            //     okText: '发送',
            //     onOk: () => {
            //         //this.sendRow(row, this.value1)
            //     },
            // })
        },
        // 发送邮箱
        sendRow() {
            let email = this.value1
            let row = this.processrow
            console.log(row, email);
            if (!email) {
                this.$Message.warning('请输入收取电子发票的邮箱地址')
                return
            }
            if (!this.$Tools.isEmail(email)) {
                this.$Message.warning('请输入正确的邮箱地址')
                return
            }
            //if(this.$Tools.isEmail('1'))
            let parms = {
                orderid: row.orderid,
                postmobile: '',
                postemail: email,
            }
            constJ.reqSendInvoice(parms).then(res => {
                console.log(res)
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        this.modal2 = false
                        this.$Message.success("发送成功！")

                    } else {
                        this.$Message.warning(res.rltdesc)
                        return
                    }
                } else {
                    this.$Message.warning(res.rtndesc)
                    return
                }
            })

        },
        show() {
            console.log('show invoice===>')
            constJ.reqGetOrderInvoicelist().then(res => {
                console.log(res)
                if (res.rltcode === 1 && res.rtncode === 1) {
                    if (res.items) {
                        this.data = res.items
                    } else {
                        this.data = []
                    }

                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.topdiv{
    background:#fff;
    padding: 5px;
    width:98%;
    margin:0 auto;
}

.main_title{
height: 20px;
font-size: 20px;
font-family: Source Han Sans CN;
font-weight: bold;
color: #2D2F33;
margin-bottom: 30px;
padding-left: 10px;
}


.mytableframe/deep/tr{
    height: 50px;
}
</style>